export default "__VITE_ASSET__B33nAZ14__"